import { Button } from '@radix-ui/themes';
import React from 'react';
import { Flex, Spinner, TextField, TextArea } from '@radix-ui/themes';
import { api } from '../../services/api';
import { useStore } from '../../store/store';
import Icon from '@mdi/react';
import { mdiCreation } from '@mdi/js';
import { Message } from 'primereact/message';

export const LoreItemCreation = ({ loreItems, setLoreItems, novelId }) => {
    const [loreItemName, setLoreItemName] = React.useState('');
    const [loreItemDescription, setLoreItemDescription] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [editMode, setEditMode] = React.useState(false);
    const [editIndex, setEditIndex] = React.useState(-1);
    const [state, actions] = useStore();

    const resetForm = () => {
        setLoreItemName('');
        setLoreItemDescription('');
    };

    const addLoreItem = () => {
        setLoreItems([...loreItems, {
            name: loreItemName,
            description: loreItemDescription
        }]);
        resetForm();
    }

    const updateLoreItem = () => {
        const updatedLoreItems = [...loreItems];
        updatedLoreItems[editIndex] = {
            name: loreItemName, 
            description: loreItemDescription
        };
        setLoreItems(updatedLoreItems);
        resetForm();
        setEditMode(false);
        setEditIndex(-1);
    }

    const dismissChanges = () => {
        resetForm();
        setEditMode(false);
        setEditIndex(-1);
    }

    const loadLoreItemData = (index) => {
        const loreItem = loreItems[index];
        setLoreItemName(loreItem.name);
        setLoreItemDescription(loreItem.description);
        setEditMode(true);
        setEditIndex(index);
    }

    const generateLoreItem = async () => {
        setIsLoading(true);
        try {
            const result = await api.generateLoreItems(novelId, 1, loreItems);
            // Since we're only generating one lore item at a time


            const generatedLoreItem = result.loreItemsGenerated[0];

            setLoreItemName(generatedLoreItem.name);
            setLoreItemDescription(generatedLoreItem.description);

        } catch (error) {
            console.error("Error generating lore item:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const deleteLoreItem = (index) => {
        const updatedLoreItems = [...loreItems];
        updatedLoreItems.splice(index, 1);
        setLoreItems(updatedLoreItems);
        
        // If we're editing the lore item that gets deleted, reset the form
        if (editMode && editIndex === index) {
            dismissChanges();
        } else if (editMode && editIndex > index) {
            // If we're editing a lore item that comes after the deleted one, adjust the index
            setEditIndex(editIndex - 1);
        }
    }

    const loreItemsMarkup = loreItems.map((loreItem, index) => {
        return (
            <div 
                key={index} 
                className={'character-create-card'}
                onClick={() => loadLoreItemData(index)}
                style={{ cursor: 'pointer', border: editMode && editIndex === index ? '2px solid #6221ab' : 'none' }}
            >
                <div className={'character-create-card-name'}>{loreItem.name}</div>
                <div className={'character-create-card-role'}>
                    {loreItem.description?.substring(0, 50)}
                    {loreItem.description?.length > 50 ? '...' : ''}
                </div>
                <button 
                    className="character-create-card-delete" 
                    onClick={(e) => {
                        e.stopPropagation();
                        deleteLoreItem(index);
                    }}
                >
                    &times;
                </button>
            </div>
        );
    });

    return (
        <div>
            <h1 style={{fontFamily: 'Poppins'}}>Lore Items</h1>

            {loreItems.length == 2 && <Message severity="info" text="Feel free to skip this step, as you can always add lore items later and not neccessary to generate chapters." />}

            <Flex gap="20px" wrap="wrap">
                {loreItemsMarkup}
            </Flex>
            <br />
            <Flex direction="column" gap="10px">
                <Flex direction="row" gap="10px">
                    <div className={'character-textarea-wrapper'}>
                        <div className='details-label'>Lore Item Name</div>
                        <TextField.Root
                            placeholder="Name"
                            value={loreItemName}
                            onChange={(e) => {setLoreItemName(e.target.value)}}
                            variant='soft'
                            className={'create-textfield'}
                        />
                    </div>
                </Flex>

                <Flex gap="30px">
                    <div className={'character-textarea-wrapper'} style={{width: '100%'}}>
                        <div className='details-label'>Description</div>
                        <TextArea 
                            className={'create-textarea character-textarea'} 
                            value={loreItemDescription} 
                            variant="soft" 
                            placeholder="Description" 
                            onChange={(e) => {setLoreItemDescription(e.target.value)}} 
                        />
                    </div>
                </Flex>
            </Flex>
            <br />
            <Flex gap="20px">
            {!editMode &&
                <Button 
                    onClick={() => {generateLoreItem()}}
                    disabled={isLoading}
                    style={{background: '#6221ab', cursor: 'pointer'}}
                >
                    {isLoading ? (
                        <Flex gap="2" align="center">
                            <Spinner size="small" />
                            <span>Generating...</span>
                        </Flex>
                    ) : (
                        <>
                            <Icon style={{transform: 'scale(0.8)'}} path={mdiCreation} size={1} />
                            {`Generate ${loreItems.length > 0 && !editMode ? 'another' : ''} Lore Item`}
                        </>
                    )}
                </Button>
            }
                <Button onClick={editMode ? updateLoreItem : addLoreItem} style={{cursor: 'pointer', background: 'hsl(227deg 40.1% 38.09%)'}}>
                    {editMode ? 'Update Lore Item' : 'Add Lore Item'}
                </Button>
                {editMode && (
                    <Button onClick={dismissChanges} style={{cursor: 'pointer', background: '#ff000088'}}>
                        Dismiss Changes
                    </Button>
                )}
            </Flex>
            <br />
        </div>
    );
};

export default LoreItemCreation;